exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5.red_text{line-height: 22px;}\n\nh2.mat-dialog-title{margin-bottom: 0px;}\n.mb_25{margin-bottom: 25px;}\n.outer_width{width:900px;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/trip/trip-edit-travel/trip-edit-travel.component.css
// module id = ../../../../../src/app/admin/trip/trip-edit-travel/trip-edit-travel.component.css
// module chunks = 39